<template>
<i :class="classes"></i>
</template>

<script>
import './font/icon-bass.css'
export default {
  name: 'Icon',
  props: {
    type: String
  },
  computed: {
    classes: function () {
      return ['ibass', 'ibass-' + this.type, 'one', 'one-' + this.type].join(' ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common-components/icon/icon.vue